import { render, staticRenderFns } from "./EditCourseTypeDialog.vue?vue&type=template&id=5f9cc855&"
import script from "./EditCourseTypeDialog.vue?vue&type=script&lang=js&"
export * from "./EditCourseTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports